import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faAddressCard, faPallet, faUserTie } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TripContext } from 'contexts';
import React, { FC, Fragment, ReactNode, useContext } from 'react';
import { Temperature } from 'services/enums';
import { StopEvent } from 'services/enums/stopEvent';
import { Company, Order, Stop, StopEquipment } from 'services/types';
import { Formatting } from 'utils';
import './appointment-info.scss';
import { PalletsRegular } from 'services/types/equipments';

type Props = {
    stopId?: number,
    stop?: Stop
}


export const AppointmentInfo: FC<Props> = ({ stopId, stop }) => {

    const tripContext = useContext(TripContext)
    const stopData: Stop = stop ?? tripContext.stops.find(s => s.id === stopId) ?? {} as Stop
    const company: Company = tripContext.companies.find(company => company.id === stopData.companyId) ?? {} as Company
    const stopEquipments: StopEquipment[] = tripContext.stopEquipments.filter(se => se.stopId === stopId) ?? []
    const palletsRegular: StopEquipment = stopEquipments.find(equipment => equipment.equipmentTypeId === PalletsRegular.Id) ?? {} as StopEquipment
    const orders = tripContext.orders.filter(x => x.stopId == stopId) ?? {} as Order[];

    const renderPhone = (): ReactNode => {
        let phone = 'No phone available'
        if (company.salesContactPhone) {
            phone = Formatting.formatPhone(company.salesContactPhone)
            if (company.salesContactExtension) {
                phone = `${phone}, ext. ${company.salesContactExtension}`
            }
        }
        return <div>{phone}</div>
    }

    const getPalletTotalByTemperature = (temperature: Temperature): number => {
        let ordersFilteredByTemperature = orders.filter(order => order.temperature === temperature);

        let sum = 0;
        ordersFilteredByTemperature.forEach(order =>{
            sum += order.totalPallets
        })

        return sum;
    }

    return (
        <div className="info-container">
            <div className="info-container-row">
                <div className="info-icon">
                    <div className="circle">
                        <FontAwesomeIcon icon={faAddressCard as IconProp} color='white' size='2x' />
                    </div>
                </div>
                <div className='info-content'>
                    <div> {company.address1} {company.address2}</div>
                    <div> {company.city}, {company.state} </div>
                    <div> {company.phone ? Formatting.formatPhone(company.phone) : 'No phone available'} </div>
                </div>
            </div>
            <div className="info-container-row">
                <div className="info-icon">
                    <div className="circle">
                        <FontAwesomeIcon icon={faUserTie as IconProp} color='white' size='2x' />
                    </div>
                </div>
                <div className='info-content'>
                    {(company.salesContactName || company.salesContactPhone) ?
                        <Fragment>
                            <div>{company.salesContactName ? company.salesContactName : 'Unknown'}</div>
                            {renderPhone()}
                        </Fragment>
                        :
                        <div>No contact information available</div>
                    }
                </div>
            </div>
            <div className="info-container-row">
                <div className="info-icon">
                    <div className="circle">
                        <FontAwesomeIcon icon={faPallet as IconProp} color='white' size='2x' />
                    </div>
                </div>

                {stopData.stopEvent !== StopEvent.LLD ?
                    (
                        <div className='info-content'>
                            <div>{`${palletsRegular.quantityIn ?? '0'} Regular Pallets`}</div>
                        </div>
                    ) : 
                    (
                        <div className='info-content'>
                            <div>Total Pallets By Temperature</div>
                            <div>{`${getPalletTotalByTemperature(Temperature.Dry)} Dry`}</div>
                            <div>{`${getPalletTotalByTemperature(Temperature.Refrigerated)} Refrigerated`}</div>
                            <div>{`${getPalletTotalByTemperature(Temperature.Frozen)} Frozen`}</div>
                            <div>{`${getPalletTotalByTemperature(Temperature.TemperatureSensitive)} TemperatureSensitive`}</div>
                        </div>
                    )
                }

            </div>
        </div>
    );
}